import "./spinner.css.js";
const n = {
  modifiers: {
    inline: "pf-m-inline",
    sm: "pf-m-sm",
    md: "pf-m-md",
    lg: "pf-m-lg",
    xl: "pf-m-xl"
  },
  spinner: "pf-v6-c-spinner",
  spinnerPath: "pf-v6-c-spinner__path"
};
export {
  n as default
};
